// @ts-nocheck
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  CustomHeader,
  TextCell,
  DateCell,
  ActionsCell,
  MoneyCell
} from '@/components/table/columns'

import {StateCell, TypeCell, RefCell} from './OperationCells'

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Reference' className='min-w-70px sortable' />,
  id: 'reference',
  Cell: ({...props}) => (
    <RefCell
      reference={props.data[props.row.index].reference}
      poNumber={props.data[props.row.index]?.po_number}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Type' className='min-w-70px sortable' />,
  id: 'type',
  Cell: ({...props}) => <TypeCell type={props.data[props.row.index].type} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Supplier' className='min-w-70px sortable' />,
  id: 'supplierName',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].supplierName} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Date' className='min-w-70px sortable' />,
  id: 'date',
  Cell: ({...props}) => (
    <DateCell
      date={props.data[props.row.index].states.at(0).date}
      format={{
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='state' className='min-w-70px' />,
  id: 'state',
  Cell: ({...props}) => <StateCell state={props.data[props.row.index].states.at(-1)} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Amount' className='min-w-70px sortable' />,
  id: 'amount',
  Cell: ({...props}) => <MoneyCell amount={props.data[props.row.index].amount} currency='EUR' />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Products' className='min-w-70px' />,
  id: 'products',
  Cell: ({...props}) => (
    <div className="text-center">
      <TextCell
        content={props.data[props.row.index].products.length}
        className="badge badge-circle badge-light-info"
        title={props.data[props.row.index].products.map(p => p.name).join(',')}
      />
    </div>
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='vouchers' className='min-w-70px text-center' />,
  id: 'vouchers',
  Cell: ({...props}) => (
    <div className="text-center">
      <TextCell
        content={props.data[props.row.index].products.reduce((acc, curr) => acc + curr.qty, 0)}
        className="badge badge-light-primary"
      />
    </div>
  )

}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => {
    let duplicate = false
    const row = props.data[props.row.index]
    const state = row.states.at(-1)?.state
    const viewAction = {
      icon: 'magnifier',
      label: 'View',
    }

    if (row.type === 'TYPE_DEPOSIT') {
      viewAction.openModal = 'deposit'
    } else {
      duplicate = row.parent === undefined
      viewAction.navigate = `/p2c/supplier/bulk-order/${props.data[props.row.index]._id}`
    }

    const actions = [viewAction]

    if (duplicate === true) {
      actions.push({
        icon: 'copy',
        label: 'Copy',
        openModal: 'duplicate'
      })
    }

    if (state === 'INIT' && row.parent === undefined) {
      actions.push({
        icon: 'trash',
        label: 'Delete',
        openModal: 'delete'
      })
    }

    if (state === 'PAID') {
      actions.push({
        icon: 'disconnect',
        label: 'split',
        openModal: 'split'
      })
    }

    return (
      <ActionsCell
        itemForUpdate={props.data[props.row.index]}
        actions={actions}
      />
    )
  }
}]

export {Columns}
